// Draft storage for the offline contact form. It lives outside the component because the
// header close button, rendered by another component, needs to act on the draft too.
// localStorage (not sessionStorage) so the draft survives returning in a new tab; the short
// TTL keeps personal data from lingering in the browser.
const KEY = 'videochat_offline_form';
const TTL_MS = 30 * 60 * 1000;

function parse() {
    const saved = localStorage.getItem(KEY);
    if (!saved) return null;
    try {
        return JSON.parse(saved);
    } catch (e) {
        return null;
    }
}

export function clearDraft() {
    localStorage.removeItem(KEY);
    // Legacy key from the previous sessionStorage-based persistence
    sessionStorage.removeItem(KEY);
}

export function readDraft() {
    const stored = parse();
    if (!stored || !stored.data || !stored.ts || Date.now() - stored.ts > TTL_MS) {
        if (stored) clearDraft();
        return null;
    }
    return stored.data;
}

export function saveDraft(data) {
    // The timestamp only moves when the content actually changes, so restoring the draft
    // on mount cannot keep renewing the TTL on every open.
    const stored = parse();
    const unchanged = stored && JSON.stringify(stored.data) === JSON.stringify(data);
    localStorage.setItem(KEY, JSON.stringify({ data, ts: unchanged ? stored.ts : Date.now() }));
}

// A draft of nothing but empty fields must not trigger the discard prompt.
export function hasDraft() {
    const data = readDraft();
    return !!data && Object.values(data).some((v) => v !== null && v !== '');
}

// Every explicit exit from the form discards the draft. Routing them through one prompt is
// what keeps them from drifting apart, which is how they got out of sync to begin with.
export function confirmDiscard(vm, message, onDiscard) {
    const discard = () => {
        clearDraft();
        onDiscard();
    };
    if (!hasDraft()) {
        discard();
        return;
    }
    vm.$confirm({
        message,
        button: {
            no: vm.$gettext('No'),
            yes: vm.$gettext('Sí')
        },
        callback: (confirmed) => {
            if (confirmed) discard();
        }
    });
}
